// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResetPassword_wrapper__3M5kc","completedMessageWrapper":"ResetPassword_completedMessageWrapper__3I57i","icon":"ResetPassword_icon__3QQJU"};